import gql from 'graphql-tag';

export const STOCK_CARD_CATEGORIES = gql`
query StockCardCategories {
  stockCardCategories {
    id
    name
  }
}
`;
export const STOCK_CARD_CATEGORY_QUERY = gql`
query StockCardCategory($id: ID!){
  stockCardCategory(id: $id) {
    id
    name
  }
}
`;